
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PageSelector extends Vue {
    @Prop({ type: Number, required: true })
    public readonly selectedPage!: number;

    @Prop({ type: Number, required: true })
    private readonly pageCount!: number;

    @Prop({ type: String, required: true })
    public readonly paperType!: string;

    @Prop({ type: String, required: true })
    public readonly orientation!: string;

    public get pageClasses(): any {
        const frameClass = 'mjegb-page-frame-' + this.orientation + '-' + this.paperType;
        return {
            [frameClass]: true,
        };
    }

    public get paginationElements(): number[] {
        const pages: number[] = [];
        const pagesWithSpacers: number[] = [];
        const last = this.pageCount;
        const current = this.selectedPage;
        const delta = 2;
        const left = current - delta;
        const right = current + delta + 1;

        for (let i = 1; i <= last; i++) {
            if (i === 1 || i === last || (i >= left && i < right)) {
                pages.push(i);
            }
        }

        let l = 0;
        let spacerId = -1;
        for (const i of pages) {
            if (l) {
                if (i - l === 2) {
                    pagesWithSpacers.push(l + 1);
                } else if (i - l !== 1) {
                    pagesWithSpacers.push(spacerId);
                    spacerId--;
                }
            }
            pagesWithSpacers.push(i);
            l = i;
        }

        return pagesWithSpacers;
    }

    public onSelectPage(index: number): void {
        if (index >= 0 && index < this.pageCount) {
            this.$emit('select', index);
        }
    }
}
